import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/staff-bg.png'


const _withScopeId = n => (_pushScopeId("data-v-0e335b40"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "img-bg"
}, null, -1))
const _hoisted_2 = { class: "main-con" }
const _hoisted_3 = { class: "user-con" }
const _hoisted_4 = { style: {"padding":"0.4rem 0 0.3rem","font-weight":"bold"} }
const _hoisted_5 = { style: {"font-size":"1rem"} }
const _hoisted_6 = { style: {"padding":"0.75rem"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold"} }, "个人简介", -1))
const _hoisted_8 = { style: {"padding-top":"0.7rem","font-size":"0.8rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_image, {
          radius: "2.5rem",
          width: "5rem",
          height: "5rem",
          src: _ctx.staff.head,
          "lazy-load": ""
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.staff.memberName), 1),
        _createElementVNode("div", _hoisted_5, "本月服务:" + _toDisplayString(_ctx.staff.serviceNum) + "次", 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.staff.staffIntroduce), 1)
      ])
    ])
  ], 64))
}